import store from "../store-root";
import api from "../../service/api";

const moduleName = "account";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    // userList: [],
    // defaultCompanyId: 0,
    enterprises: []
  },
  actions: {
    //创建或者选择单位
    async addUserCompany({ commit }, payload) {
      var result = await api.post(`/api/Enterprise`, payload);
      return result.data;
    },
    //获得用户的企业信息（创建企业时用）
    async getCompanyInfo({ commit }) {
      var result = await api.get("/api/Enterprise");
      return result.data;
    },
    //获取切换公司下拉列表(切换公司用)
    async getUserCompany({ commit }) {
      var result = await api.get("/api/Enterprise/GetCompanyList");
      commit("setCompany", result.data);
      return result.data;
    },
    //切换渔场(公司)
    async changeCompany({ commit }, payload) {
      commit("permission/clearQlwPermissions", null, { root: true });
      var result = await api.get(`/api/Enterprise/ChangeEnterprise/${payload}`);
      return result.data;
    }

    // async getUserList({ commit }) {
    //   let result = await api.get("/api/user", {
    //     adapter: async () => {
    //       return {
    //         data: [1, 2, 3, 4, 5, 6]
    //       };
    //     }
    //   });
    //   commit("setUserList", result.data);
    //   return result;
    // },
    // async getUserCompany({ commit }) {
    //   var result = await api.get(`/api/Enterprise`);
    //   commit("setCompany", result.data);
    //   return result.data;
    // },
    // async switchCompany({ commit, state }, payload) {
    //   await api.post(`/api/Account/SwitchEnterprise/${payload}`);
    //   commit("setCompany", {
    //     default: payload,
    //     enterprises: state.enterprises
    //   });
    // }
  },
  mutations: {
    // setUserList(state, payload) {
    //   state.userList = payload;
    // },
    setCompany(state, payload) {
      // state.enterprises = payload;
      state.enterprises = [
        {
          enterpriseId: "-2",
          enterpriseName: "创建渔场"
        }
      ].concat(payload);
    }
  },
  getters: {
    // getUserListWithOutls(state) {
    //   return state.userList.filter(f => f !== "李四");
    // }
    // getCompany(state) {
    //   if (state.enterprises && state.enterprises.length !== 0) {
    //     let item = state.enterprises.find(f => f.id == state.defaultCompanyId);
    //     if (item) {
    //       return item.name;
    //     }
    //   }
    // }
  }
});

export default moduleName;
